module.exports = __webpack_public_path__ + "img/ie.738c4462.svg";